// src/components/store/sections/faqs/FaqV103AccordioncleanSlateGold.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV103AccordioncleanSlateGold(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={103}
      archKey="accordion_clean"
      archLabel="Clean Emerald Accordion"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
